import React from "react";
import { observer } from "mobx-react-lite";
import styled from "@emotion/styled";
import { Column } from "@src/components/Flex";
import { TPoolStats } from "@src/stores/LendStore";
import { useMarketModalVm } from "@screens/MarketPage/MarketModals/MarketModalVM";
import { OPERATIONS_TYPE } from "@src/constants";

import RepayAssets from "@screens/MarketPage/MarketModals/RepayAssets";
import SupplyAssets from "@screens/MarketPage/MarketModals/SupplyAssets";
import WithdrawAssets from "@screens/MarketPage//MarketModals/WithdrawAssets";
import BorrowAssets from "@screens/MarketPage/MarketModals/BorrowAssets";

type UrlParamsTypes = {
  tokenId?: string;
  marketId?: string;
};

interface IProps {
  urlParams: UrlParamsTypes;
  operationName: OPERATIONS_TYPE;
  tokenStats: TPoolStats;
  onClose: () => void;
}

const Root = styled(Column)`
  width: 100%;
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors.white};

  & > * {
    width: 100%;
  }
`;

const MarketModalBody: React.FC<IProps> = ({
  operationName,
  tokenStats,
  urlParams,
  onClose
}) => {
  const vm = useMarketModalVm();

  return (
    <Root>
      {operationName === OPERATIONS_TYPE.SUPPLY && (
        <SupplyAssets
          token={tokenStats}
          marketId={urlParams?.marketId || vm.currentMarketId}
          modalAmount={vm.modalAmount}
          modalSetAmount={vm.setVMamount}
          onMaxClick={vm.triggerMaxClickFunc}
          onSubmit={vm.submitSupply}
          onClose={onClose}
        />
      )}
      {operationName === OPERATIONS_TYPE.WITHDRAW && (
        <WithdrawAssets
          token={tokenStats}
          marketId={urlParams?.marketId || vm.currentMarketId}
          userHealth={vm.userHealth}
          modalAmount={vm.modalAmount}
          modalSetAmount={vm.setVMamount}
          onMaxClick={vm.triggerMaxClickFunc}
          onSubmit={vm.submitWithdraw}
          onClose={onClose}
        />
      )}
      {operationName === OPERATIONS_TYPE.BORROW && (
        <BorrowAssets
          token={tokenStats}
          marketId={urlParams?.marketId || vm.currentMarketId}
          userHealth={vm.userHealth}
          modalAmount={vm.modalAmount}
          modalSetAmount={vm.setVMamount}
          onMaxClick={vm.triggerMaxClickFunc}
          onSubmit={vm.submitBorrow}
          onClose={onClose}
        />
      )}
      {operationName === OPERATIONS_TYPE.REPAY && (
        <RepayAssets
          token={tokenStats}
          marketId={urlParams?.marketId || vm.currentMarketId}
          modalAmount={vm.modalAmount}
          modalSetAmount={vm.setVMamount}
          onMaxClick={vm.triggerMaxClickFunc}
          onSubmit={vm.submitRepay}
          onClose={onClose}
        />
      )}
    </Root>
  );
};
export default observer(MarketModalBody);
